<template>
  <div>
    <div class="row">
      <div class="col-12">
        <page-header
          :page="page"
          @onReturn="() => $router.back()"
          :has-return="true"
       />
      </div>
    </div>
    <div class="row">
      <div class="col">
        <filter-manager
          :display-advanced="false"
          class="search-bar"
          items-container-class="flex-wrap"
          search-icon="fa fa-sync"
          search-text="Procesar"
          search-container-class="btn-process"
          v-model="model.search.filters"
          :filters="filterManagerConfig"
          @search="onHandlerSearch"
          ref="filterRef"
        />
      </div>
    </div>
  </div>
</template>

<script>
import PageHeader from 'PageHeader'
import FilterManager from 'FilterManager'
import AcademicYearServices from '@/services/api/academicyear.api'
import ProviderServices from '@/services/api/provider.api'
import TherapyServices from '@/services/api/thrpy.api'
import CodeServices from '@/services/api/code.api'
import ReportServices from '@/modules/report/api'
import DocumentServices from '@/modules/report/document'

export default {
  components: {
    PageHeader,
    FilterManager,
  },
  data: () => 
  ({
    page: {
      icon: 'fas fa-clipboard-list-check',
      title: 'Hallazgos UMESR',
      routes: ["Informes", "Hallazgos UMESR"]
    },
    model: {
      search: {
        collections: {
          academicYears: [],
          providers:[],
          reasons:[],
          statuses:[]
        },
        filters: {
          academicYear: null,
          provider: null,
          reason: null,
          status: null
        },
      },
    },
  }),
  computed: {
    filterManagerConfig() {
    return [
      {
        name: 'academicYear',
        component: 'custom-drop-down',
        fieldKey: 'id',
        fieldName: 'description',
        label: 'Año Académico',
        placeholder: 'Seleccionar',
        error: "Favor seleccionar un año académico.",
        validations: "required",
        clearable: false,
        options: this.model.search.collections.academicYears,
        value: this.model.search.filters.academicYear,
        onChanged:this.onAcademicYearSelected
      },
      {
        name: 'provider',
        component: 'custom-drop-down',
        fieldKey: 'id',
        fieldName: 'name',
        label: 'Proveedor',
        placeholder: 'Seleccionar',
        validations: "",
        clearable: false,
        options: this.model.search.collections.providers,
        value: this.model.search.filters.provider,
      },
      {
        name: 'reason',
        component: 'custom-drop-down',
        fieldKey: 'id',
        fieldName: 'name',
        label: 'Hallazgo',
        placeholder: 'Seleccionar',
        validations: "",
        clearable: false,
        options: this.model.search.collections.reasons,
        value: this.model.search.filters.reason,
      },
      {
        name: 'status',
        component: 'custom-drop-down',
        fieldKey: 'id',
        fieldName: 'name',
        label: 'Estatus',
        placeholder: 'Seleccionar',
        validations: "",
        clearable: false,
        options: this.model.search.collections.statuses,
        value: this.model.search.filters.status,
      }
    ]
    },
  },
  async mounted() {
    await this.setFilters();
  },
  methods: {
    async setFilters() {
      await AcademicYearServices.getCurrentYearAcademicYears()
        .then(res => this.model.search.collections.academicYears = res.data);

      await CodeServices.getMonitoringStatuses()
        .then(res => this.model.search.collections.reasons = res.data);  
      
      await TherapyServices.getAdjustmentReasons(true)
        .then(res => this.model.search.collections.statuses = res.data);  

    },
    async onAcademicYearSelected(){
      await ProviderServices.getAllProvidertCompaniesByYear({AcademicYearId: this.model.search.filters.academicYear?.id})
        .then(res => this.model.search.collections.providers = res.data);
    },
    async onHandlerSearch() {
      this.process();
    },
    async process() {
      if( this.model.search.filters.academicYear )
         {
            await ReportServices.getReport('umesrfindings', {
            academicYearId:  this.model.search.filters.academicYear.id,
            companyId: this.model.search.filters.provider?.id,
            reasonId: this.model.search.filters.reason?.id,
            statusId: this.model.search.filters.status?.id
            })
            .then(res => DocumentServices.Download(res.data));
         }
    },
  },
}
</script>